import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { StrictMode, startTransition, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';
import packageJson from '../package.json';
import tracking from './.client/tracking';

Sentry.init({
  dsn: 'https://5553b736ca10bde79a0378e7dc7788f5@o328429.ingest.us.sentry.io/4508607159074816',
  environment: window.env.APP_ENV,
  enabled: window.env.APP_ENV !== 'development',
  release: `web@${packageJson.version}`,
  tracesSampleRate: window.env.APP_ENV === 'production' ? 0.1 : 1,

  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});

tracking.init();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
  );
});
